export default {
    props: ["value"],
    data() {
        return {
            listNumbers: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
            number: this.value !== null ? this.formateNumber(String(this.value)) : "",
            copyNumber: this.value
        };
    },
    methods: {
        /**
         * Agrega, valida y formatea el valor numérico
         * @param {event} event
         */
        addNumber(event) {
            const element = this.$refs.inputNumber;
            if (this.listNumbers.includes(event.key)) {
                if (this.number.length === 1 && this.number === "0") this.number = "";
                else {
                    if (element.selectionStart === 1 && element.selectionEnd === 1) {
                        this.copyNumber = event.key;
                    } else this.copyNumber += event.key;
                }
                this.number = this.formateNumber(this.copyNumber);
            } else {
                if (event.key === "Backspace" || event.key === "Delete") {
                    if (element.selectionStart === 0 && element.selectionEnd === this.number.length) {
                        this.number = "";
                        this.copyNumber = "";
                    } else {
                        this.copyNumber = this.removeFormatter(this.number);
                    }
                }
                this.number = this.formateNumber(this.copyNumber);
            }
            this.$emit("input", parseInt(this.removeFormatter(this.number)));
        },
        /**
         * Formatea el valor numérico para agregar los apostrofes de millon y los puntos de mil
         * @param {string} copyNumber
         */
        formateNumber(copyNumber) {
            let result = copyNumber.replace(/(\d)(?=(\d\d\d\d\d\d)+(?!\d))/g, "$1'");
            result = result.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");
            return result;
        },
        /**
         * Remueve los puntos y apostrofes
         * @param {string} number
         */
        removeFormatter(number) {
            let result = number.replace(/[',.]/g, "");
            return result;
        }
    }
};
